import React from 'react'
import { Form, InputNumber, Tooltip, Input, Button, Popconfirm } from 'antd';
import TextEditor from '../../text/TextEditor';


export default function CharacterModalSlExtension({
    newCharacter,
    setSomethingChanged,
    handleChangeTextEditorSlNotes,
    onClickSlChangeStatus
}) {

    return (

        <>
            <Form.Item
                label="User"
            >
                <Input disabled value={newCharacter.larper?.name}/>
            </Form.Item>

            <Form.Item
                label="Skillpoints from events"
                name="eventSkillPoints"
            >
                <InputNumber name="eventSkillPoints" onChange={() => setSomethingChanged(true)}/>
            </Form.Item>

                <Form.Item
                label="SL notes"
                name="slNotes"
                tooltip={
                    <Tooltip>
                        <span>Players wont see this</span>
                    </Tooltip>
                }
            >
                <TextEditor 
                    content={newCharacter.slNotes}
                    onChange={handleChangeTextEditorSlNotes}
                />
            </Form.Item>

            <Popconfirm title="Sure to kill?" onConfirm={() => onClickSlChangeStatus("Dead")}>
                 <Button danger  
                >
                    Kill character
                </Button>
            </Popconfirm>
        </>
    )
}